import { FormattedMessage } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';

export const TradingNameQuestion = (props) => {
    const { onChange } = props;

    return (
        <FormField
            className="fs-exclude"
            label={
                <FormattedMessage
                    id="_.your_company.trading_name"
                    defaultMessage="Trading name"
                />
            }
            name="tradingName"
            id="tradingName"
            onChangeHandler={onChange}
        />
    );
};
